import React from "react";
import Warning from "MODULES/shared/components/Warning/Warning";

export default function ConditionWarning() {
  return (
    <Warning>
      Heads Up! - The condition of this item has been changed from its original
      condition. Are you sure you want to continue?
    </Warning>
  );
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/shared/Warnings/ConditionWarning.jsx